export const SUPPORTED_LOCALES = ["en", "es", "ja", "ko", "zh"];
export const DEFAULT_LOCALE = "en";

export function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale);
}

export function localeToPathPrefix(locale) {
  if (!locale || locale === DEFAULT_LOCALE) return "";
  return `/${locale}`;
}

export function normalizeLocaleFromPathname(pathname) {
  // Accept:
  // - "/" -> en
  // - "/ja/..." -> ja
  const seg = (pathname || "/").split("/")[1];
  if (!seg) return DEFAULT_LOCALE;
  return isSupportedLocale(seg) ? seg : DEFAULT_LOCALE;
}

function matchSupportedLocale(tag) {
  const lang = String(tag || "").toLowerCase();
  // Examples: "ja", "ja-JP", "zh-Hans", "zh-Hant", "ko-KR", "es-ES"
  if (lang.startsWith("es")) return "es";
  if (lang.startsWith("ja")) return "ja";
  if (lang.startsWith("ko")) return "ko";
  if (lang.startsWith("zh")) return "zh";
  if (lang.startsWith("en")) return "en";
  return null;
}

/** Uses navigator.languages (Firefox/Chrome preference order), then navigator.language. */
export function detectBrowserLocale() {
  const candidates =
    typeof navigator !== "undefined" && navigator.languages?.length
      ? [...navigator.languages]
      : [navigator?.language || DEFAULT_LOCALE];

  for (const tag of candidates) {
    const matched = matchSupportedLocale(tag);
    if (matched) return matched;
  }

  return DEFAULT_LOCALE;
}

export function stripLocalePrefix(pathname) {
  const parts = (pathname || "/").split("/");
  const first = parts[1];
  if (isSupportedLocale(first) && first !== DEFAULT_LOCALE) {
    const rest = "/" + parts.slice(2).join("/");
    return rest === "/" ? "/" : rest.replace(/\/+$/, "") || "/";
  }
  return pathname || "/";
}

